import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MaterialIcon } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import Link from 'data/Link';
import AppHeader from 'components/AppHeader';
import AppBackButton from 'components/AppBackButton';
import {
  PageWrapper,
  PageViewport,
} from 'components/PageStyles';
import gtmService from 'utils/gtm/gtmService';

import { KNOWLEDGE } from '../../associations/types';
import KnowledgeSidebar from '../../components/KnowledgeSidebar';
import KnowledgeMapDetailsDrawerContainer from '../../containers/KnowledgeMapDetailsDrawerContainer';
import TreeView from '../../components/TreeView';

import { ContentWrapper } from './styles';
import messages from './messages';
import { pageName, GTM_EVENT_TYPES } from 'utils/gtm/constants';

class KnowledgeContent extends React.Component {
  state = {
    sidebarOpened: true,
    isRootNodeSelected: false,
  };

  componentDidMount() {
    gtmService.gtmTrackEvent({ eventType: GTM_EVENT_TYPES.PAGEVIEW, payload: { pageName: pageName.CONTENT_PAGE } });
  }

  toggleSidebar = () => {
    this.setState({
      sidebarOpened: !this.state.sidebarOpened,
    });
  };

  deselectItem = () => {
    const { knowledgeMap, historyPush } = this.props;
    const { isRootNodeSelected } = this.state;
    if (isRootNodeSelected) {
      this.setState({ isRootNodeSelected: false });
    }
    historyPush(`/knowledge/${knowledgeMap.id}/content`);
  };

  selectItem = (item) => {
    const { knowledgeMap, historyPush } = this.props;
    if (knowledgeMap.id === item.id) {
      this.setState({ isRootNodeSelected: true });
      return;
    }
    this.setState({ isRootNodeSelected: false });
    historyPush(`/knowledge/${item.documentId}/content/${item.id}`);
  };

  getSelectedItem = (knowledgeMap, selectedItemId, isRootNodeSelected) => {
    if (isRootNodeSelected) {
      return knowledgeMap;
    }
    return (
      selectedItemId &&
      knowledgeMap.items.find((item) => item.id === selectedItemId)
    );
  };

  render() {
    const { sidebarOpened, isRootNodeSelected } = this.state;
    const { knowledgeMap, selectedItemId } = this.props;
    const selectedItem = this.getSelectedItem(
      knowledgeMap,
      selectedItemId,
      isRootNodeSelected
    );

    return (
      <div>
        <AppHeader
          IconComponent={(props) => (
            <AppBackButton type={KNOWLEDGE} route="/knowledge" {...props} />
          )}
          links={[
            new Link("/knowledge", <MaterialIcon id="home" />),
            new Link(
              `/knowledge/${knowledgeMap.id}/content`,
              knowledgeMap.title
            ),
          ]}
        />
        <PageWrapper hasAppHeader>
          <Helmet>
            <title>{intl.formatMessage(messages.title)}</title>
          </Helmet>

          {!selectedItem && sidebarOpened && <KnowledgeSidebar />}
          {selectedItem && (
            <KnowledgeMapDetailsDrawerContainer
              knowledgeMap={knowledgeMap}
              knowledgeMapItem={selectedItem}
              onClose={this.deselectItem}
              isRootNodeSelected={isRootNodeSelected}
            />
          )}

          <PageViewport>
            <ContentWrapper>
              {knowledgeMap && knowledgeMap.items && (
                <TreeView
                  competencyDocument={knowledgeMap}
                  onSelect={this.selectItem}
                  selectedItemId={selectedItemId}
                />
              )}
            </ContentWrapper>
          </PageViewport>
        </PageWrapper>
      </div>
    );
  }
}

KnowledgeContent.propTypes = {
  historyPush: PropTypes.func.isRequired,
  knowledgeMap: PropTypes.object,
  selectedItemId: PropTypes.string,
  location: PropTypes.object,
};

export default KnowledgeContent;
